{
	"stageLabel": "Sector {{n}}",
	"stageName": {
		"ENTRIES": "Early Planning Phase",
		"ACCREDITATION": "Approval & Verification for Accreditation",
		"LOGISTICS": "Logistics & Hospitality",
		"CONTINGENT": "Contingent Management Module"
	},
	"modules": {
		"entries": "EOI & EBN",
		"registration": "Registration (all categories)",
		"travel": "Arrival & Departure",
		"transport": "Transportation",
		"accommodation": "Accommodation",
		"fnb": "Food & Beverages",
		"shortlist": "Shortlist",
		"e_accreditation": "E-Accreditation",
		"helpdesk": "Helpdesk",
		"dashboard": "Dashboard and other pages",
		"contingent": "Contingent dashboard"
	},
	"locked": {
		"title": "Not open yet",
		"body": "{{page}} opens in Sector {{n}} ({{stage}}). The organising committee will let you know.",
		"bodyUnknown": "{{page}} is not open to NOCs yet. The organising committee will let you know.",
		"goTo": "Go to {{page}}",
		"trackLabel": "NOC sectors",
		"youAreHere": "You are here",
		"opensHere": "Opens here"
	},
	"nav": {
		"locked": "Not open yet",
		"lockedTitle": "{{page}} (not open yet)"
	},
	"page": {
		"intro": "NOCs see only the parts of the GMS that are open in their sector. Each sector keeps everything before it. Admins and host staff are never affected.",
		"readOnly": "Only a super admin can change sectors.",
		"stagesLabel": "Sectors"
	},
	"card": {
		"current": "Current",
		"opens": "Opens",
		"adds": "Adds to Sector {{n}}",
		"nocCount_one": "{{count}} NOC in this sector",
		"nocCount_other": "{{count}} NOCs in this sector",
		"moveAll": "Move all NOCs to this sector"
	},
	"table": {
		"title": "NOCs",
		"changed": "Current sector set {{when}}",
		"noc": "NOC",
		"stage": "Sector",
		"exception": "Exception",
		"override": "Sector setting",
		"followAll": "Follow all (Sector {{n}})",
		"followAllPlain": "Follow all",
		"onlyStage": "Sector {{n}}: {{stage}}",
		"overrideFor": "Sector setting for {{org}}",
		"emptyTitle": "No NOCs yet",
		"emptyHint": "NOC organisations appear here once they are set up under Responsible Organizations."
	},
	"confirm": {
		"allTitle": "Move all NOCs to Sector {{n}}?",
		"allBody": "Every NOC that follows all moves to Sector {{n}} ({{stage}}) and sees its pages at once. NOCs with an exception keep their own sector.",
		"allAction": "Move to Sector {{n}}",
		"orgTitle": "Change the sector of {{org}}?",
		"orgFollowBody": "{{org}} follows all NOCs again, in Sector {{n}} today.",
		"orgSetBody": "{{org}} stays in Sector {{n}} ({{stage}}), whatever sector the other NOCs are in.",
		"orgAction": "Save sector",
		"reason": "Reason",
		"reasonHint": "Shown in the activity log.",
		"reasonRequired": "Give a reason for this change."
	},
	"done": {
		"all": "All NOCs moved to Sector {{n}}.",
		"org": "Sector saved for {{org}}."
	},
	"failed": "Couldn't change the sector"
}
